<template>
  <div>
    <vxe-table
      border
      show-overflow
      resizable
      ref="settleAccountsRef"
      class="vxe-table-element"
      size="mini"
      align="center"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumns"
      :valid-config="{ autoPos: true, message: 'inline' }"
      height="400"
      :key="keyTime"
      :loading="loading"
    >
      <vxe-table-column type="seq" width="50px" title="序号"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.field"
        :title="item.title ? $t(item.title) : null"
        :visible="item.visible"
        :type="item.type"
        :width="item.width"
      >
        <template v-slot="{ row }">
          <template v-if="item.field === 'contractNo'">
            <a @click="jumpToContractDetail(row)" href="#" style="color: blue; cursor: pointer">{{
              row[item.field]
            }}</a>
          </template>
          <template v-else-if="item.field === 'expenseNo'">
            <a @click="jumpExpenseList(row)" href="#" style="color: blue; cursor: pointer">{{
              row[item.field]
            }}</a>
          </template>
          <template v-else-if="item.field === 'receivableSettlementNo'">
            <a @click="jumpSettlementDetail(row)" href="#" style="color: blue; cursor: pointer">{{
              row[item.field]
            }}</a>
          </template>
          <template v-else-if="item.field === 'processStatus'">{{
            row.processStatus == '0' ? '未处理' : '已处理'
          }}</template>
          <!-- 结算类型 -->
          <template v-else-if="item.field === 'settlementType'">{{
            row.settlementType == '1' ? '预结算' : '终结算'
          }}</template>
          <!-- 单据状态 -->
          <template v-else-if="item.field === 'settlementStatus'">{{
            settlementStatus?.find((item) => item.value == row['settlementStatus'])?.label
          }}</template>
          <!-- 开票状态 -->
          <template v-else-if="item.field === 'settlementIssueStatus'">{{
            settlementIssueStatus?.find((item) => item.value == row['settlementIssueStatus'])?.label
          }}</template>
          <!-- 收款状态 -->
          <template v-else-if="item.field === 'receiveStatus'">{{
            settlementReceiveStatus?.find((item) => item.value == row['receiveStatus'])?.label
          }}</template>
          <!-- 付款状态 -->
          <template v-else-if="item.field === 'paymentStatus'">{{
            payPaymentStatus?.find((item) => item.value == row['paymentStatus'])?.label
          }}</template>
          <template v-else-if="item.field === 'productUnit'">{{
            produceBasicUnit?.find((item) => item.value == row['productUnit'])?.label
          }}</template>
          <template v-else-if="item.field === 'contractStatus'">{{
            contractStatus?.find((item) => item.value == row['contractStatus'])?.label
          }}</template>
          <template v-else>{{ row[item.field] }}</template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <!-- 分页 -->
    <IPagination
      :total="tableTotal"
      :multipleSelection="multipleSelection"
      @changePageHandler="changePageHandler"
      ref="ipaginationRef"
    />
  </div>
</template>

<script>
  import { formatDate } from '@/utils';
  import API from '@/api/homepage/overdueReminder.js';
  import {
    awaitingDispatch,
    pendingReceiptSettlement,
    pendingPayableSettlement,
    pendingCollectInvoice,
    pendingInvoice,
    pendingPayment,
    pendingReceiptPayment,
    pendingPickup,
  } from './baseTable.js';
  export default {
    name: 'BeingOverdue',
    props: ['orderName', 'activeTab', 'indexType'],
    mixins: [],
    data() {
      return {
        tableData: [],
        tableTotal: 5,
        tableApi: '',
        queryParam: {},
        multipleSelection: [],
        keyTime: new Date().getTime(),
        loading: false,
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
      };
    },
    computed: {
      tableColumns() {
        switch (this.orderName) {
          case '待发货':
            return awaitingDispatch();
          case '待应收结算':
            return pendingReceiptSettlement();
          case '待应付结算':
            return pendingPayableSettlement();
          case '待收进项发票':
            return pendingCollectInvoice();
          case '待开票':
            return pendingInvoice();
          case '待付款':
            return pendingPayment();
          case '部分付款':
            return pendingPayment();
          case '待收款':
            return pendingReceiptPayment();
          case '待提货':
            return pendingPickup();
        }
        return [];
      },
      settlementStatus() {
        return this.dictListMap?.settlementStatus;
      },
      settlementIssueStatus() {
        return this.dictListMap?.settlementIssueStatus;
      },
      settlementReceiveStatus() {
        return this.dictListMap?.settlementReceiveStatus;
      },
      payPaymentStatus() {
        return this.dictListMap?.pay_paymentStatus;
      },
      produceBasicUnit() {
        return this.dictListMap?.basic_unit;
      },
      contractStatus() {
        return this.dictListMap?.contract_status_wm;
      },
    },
    mounted() {
      this.businessGroup = this.userInfo.businessGroup;
      // this.getTableData();
    },
    methods: {
      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
        this.page.pageNum = pageNum;
        this.page.pageSize = pageSize;
        this.getTableData(this.orderName);
      },
      async getTableData() {
        console.log('tableApi', this.tableApi, 'queryParam', this.queryParam);
        let postData = {
          // companyCode: this.userInfo.companyCode,
          // departmentCode: this.userInfo.departmentCode,
          // settlementCompanyNo: this.userInfo.companyCode,
          departmentCodeList: this.userInfo.allDepartmentList.map((v) => v.personDepartmentCode),
          // settlementDepartmentNo: this.userInfo.departmentCode,
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
          adminFlag: '2',
          businessGroup: this.userInfo.businessGroup,
        };
        const newData = new Date();
        const leaseDateUntilStart = formatDate(newData, true);
        const leaseDateUntilEnd = formatDate(
          new Date(newData.setDate(newData.getDate() + 30)),
          true
        );
        this.loading = true;
        const { data } = await this.$axios.post(this.tableApi, postData);
        this.loading = false;
        if (data.code == 0) {
          this.tableData = data.data.records;
          this.tableTotal = data.data.total;
        }
        console.log('日期', leaseDateUntilStart, leaseDateUntilEnd);
      },
      jumpToContractDetail(row) {
        let path = '';
        let name = '';
        let title = '';
        let query = {};
        if (row.contractNo.includes('GN-XS-') || row.contractNo.includes('XSHT')) {
          const { contractDetailCategory, contractNo, id, contractStatus } = row;
          // if (contractDetailCategory == 'CG04') {
          path = '/salePurchase/wumaoSaleContractEdit';
          name = 'wumaoSaleContractEdit';
          title = '销售合同编辑';
          query = {
            id: id,
            type: contractDetailCategory,
            contractNo: contractNo,
            contractCategory: 'sales',
            isEdit: contractStatus === 'ZT03' ? true : false,
          };
        } else if (row.contractNo.includes('GN-CG-') || row.contractNo.includes('CGHT')) {
          const contractDetailCategory = row.contractDetailCategory;
          const contractNo = row.contractNo;
          const id = row.id;
          // 采购合同
          // if (contractDetailCategory == 'CG01') {
          path = '/salePurchase/wumaoContractEdit';
          name = 'wumaoContractEdit';
          title = '采购合同编辑';
          query = {
            id: id,
            type: contractDetailCategory,
            contractNo: contractNo,
            isEdit: true,
            contractCategory: 'purchase',
          };
        } else if (row.contractNo.includes('GN-SB')) {
          path = '/saleManage/bilateralContractDetail';
          name = 'bilateralContractDetail';
          title = '双边合同详情';
          query = {
            status: 'detail',
            id: row.id,
            contractNo: row.contractNo,
            contractCategory: row.contractCategory,
          };
        }

        // 物贸
        let routepath = {
          path: path,
          name: name,
          meta: {
            keepAlive: true,
            title: title,
          },
          query: query,
        };
        this.$router.push(routepath);
      },
      // 跳转费用清单列表
      jumpExpenseList(row) {
        let path = '';
        let name = '';
        let title = '';
        let query = {};
        if (row.expenseNo.includes('YS')) {
          path = 'receivablesAndPayables/receivables';
          title = '贸易应收结算单';
          name = 'receivables';
          query = {
            contractNo: row.contractNo,
            processStatus: row.processStatus,
          };
        } else if (row.expenseNo.includes('YF')) {
          path = 'receivablesAndPayables/payables';
          title = '贸易应付结算单';
          name = 'payables';
          query = {
            contractNo: row.contractNo,
            processStatus: row.processStatus,
          };
        }
        let routepath = {
          path: path,
          name: name,
          meta: {
            keepAlive: true,
            title: title,
          },
          query: query,
        };
        this.$router.push(routepath);
      },
      // 跳转结算单详情
      jumpSettlementDetail(row) {
        let path = '';
        let name = '';
        let title = '';
        let query = {};
        if (row.payableSettlementNo) {
          path = 'receivablesAndPayables/tradePayablesDetail';
          title = '贸易应付结算单';
          name = 'tradePayablesDetail';
          query = {
            status: 'detail',
            payNo: row.payableSettlementNo,
            id: row.id,
          };
        } else if (row.receivableSettlementNo) {
          path = 'receivablesAndPayables/tradeReceivablesDetail';
          title = '贸易应收结算单';
          name = 'tradeReceivablesDetail';
          query = {
            status: 'detail',
            id: row.id,
            receiveNo: row.receivableSettlementNo,
          };
        }
        let routepath = {
          path: path,
          name: name,
          meta: {
            keepAlive: true,
            title: title,
          },
          query: query,
        };
        this.$router.push(routepath);
      },
    },
    watch: {
      orderName: {
        handler(val) {
          if (val) {
            switch (this.orderName) {
              case '待发货':
                this.tableApi = API.WM_WAIT_DELIVER;
                // 暂未使用
                this.queryParam = {
                  dataStatus: '01',
                };
                break;
              case '待应收结算':
                this.tableApi = API.RECEIVABLE_SETTLEMENT_EXPENSE;
                this.queryParam = {
                  dataStatus: '01',
                };
                break;
              case '待应付结算':
                this.tableApi = API.PAYABLE_SETTLEMENT_EXPENSE;
                this.queryParam = {
                  dataStatus: '01',
                };
                break;
              case '待收进项发票':
                this.tableApi = API.RETURN_TICKET;
                this.queryParam = {
                  dataStatus: '01',
                };
                break;
              case '待开票':
                this.tableApi = API.FINANCE_SALES_INVOICE;
                this.queryParam = {
                  dataStatus: '01',
                };
                break;
              case '待付款':
                this.tableApi = API.OVERDUE_REMINDER;
                this.queryParam = {
                  dataStatus: '01',
                };
                break;
              case '部分付款':
                this.tableApi = API.COMPLETE_PAYMENT;
                this.queryParam = {
                  dataStatus: '01',
                };
                break;
              case '待收款':
                this.tableApi = API.FUND_COLLECTION;
                this.queryParam = {
                  dataStatus: '01',
                };
                break;
              case '待提货':
                this.tableApi = API.WM_WAIT_CARRY;
                this.queryParam = {
                  dataStatus: '01',
                };
                break;
            }
            this.getTableData();
            console.log('重新加载了数据', val);
          }
        },
        deep: true,
        immediate: true,
      },
    },
  };
</script>

<style></style>
